import React from "react";
import { connect } from "react-redux";
import { logout } from "../../store/WriteClass";
import "./index.css";
import SiteConfig from "site-config.json";
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";

const has_header_img =
  SiteConfig.hasOwnProperty("header-main") &&
  SiteConfig["header-main"].length > 0;
const has_header_border =
  SiteConfig.hasOwnProperty("header-border-color") &&
  SiteConfig["header-border-color"].length > 0;
const has_header_font_color =
  SiteConfig.hasOwnProperty("header-font-color") &&
  SiteConfig["header-font-color"].length > 0;


const headerMain = {
  height: "109px",
  background: has_header_img
    ? `url(${SiteConfig["header-main"]})`
    : SiteConfig["header-color"],
  borderBottom: has_header_border
    ? `5px solid ${SiteConfig["header-border-color"]}`
    : ""
};

const headerWelcome = {
  color: has_header_font_color
    ? `${SiteConfig["header-font-color"]}`
    : ""
};

let compy = ({ user, loggedIn }) => {
  let conditional = "";

  if (user && user.email && loggedIn) {
    conditional = (
      <div className="headerProfileWrapper">
        <div className="headerProfile visible-xs">
          <DropdownButton
            title={`${user.firstName} ${user.lastName}`}
            id="account-dropdown"
          >
            <MenuItem
              style={{
                minWidth: 100
              }}
              onSelect={() =>
                (window.location = process.env.REACT_APP_API_URL + "/logout")
              }
            >
              Log Out
            </MenuItem>
          </DropdownButton>
        </div>
        <div className="headerProfile hidden-xs">
          <div className="headerWelcome" style={headerWelcome}>
            Welcome, {user.firstName} {user.lastName}
          </div>
          {SiteConfig["logout-color"] && SiteConfig["logout-font-color"] ? (
            <a
              className="btn"
              role="button"
              href={process.env.REACT_APP_API_URL + "/logout"}
              style={{
                backgroundColor: SiteConfig["logout-color"],
                color: SiteConfig["logout-font-color"]
              }}
            >
              Log Out
            </a>
          ) : (
            <a href={process.env.REACT_APP_API_URL + "/logout"} role="button">
              <img
                src={SiteConfig.logout}
                className="logoutButton"
                title="Log out"
                alt="log out"
              />
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <header>
      <div className="headerWrap">
        <div className="headerMain" style={headerMain}>
          <div className="headerInterior">
            <div className="headerLogoWrapper">
              <a href="/" title="Home link">
                <img
                  src={SiteConfig.logo}
                  alt="header-logo"
                  className="headerLogo"
                />
              </a>
            </div>
            {conditional}
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = state => ({
  user: state.write_class.user,
  loggedIn: state.write_class.loggedIn
});

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout())
  };
}

const wrappedCompy = connect(
  mapStateToProps,
  mapDispatchToProps
)(compy);

export default wrappedCompy;



// WEBPACK FOOTER //
// ./src/components/appHeader/index.jsx